import { BrowserRouter, Route, Routes } from 'react-router-dom';
import ElevatePage from './ElevatePage';
import HomePage from './HomePage';
import Kpop3Page from './Kpop3Page';
import ManiaaaPage from './ManiaaaPage';

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<HomePage />} />
        <Route path="/elevate" element={<ElevatePage />} />
        <Route path="/maniaaa" element={<ManiaaaPage />} />
        <Route path="/kpop3" element={<Kpop3Page />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
